export type TipstersConfig = {
  path: string;
  ui?: {
    pointsUnit: string;
  };
};

export const TIPSTERS_CONFIG = {
  GZ: {
    path: 'premium-tipsters',
    ui: {
      pointsUnit: 'pts',
    },
  },
  OC: {
    path: 'premium-tipsters',
  },
  US: {
    path: 'premium-picks',
  },
};
